import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  RequiredUserAction,
  RequiredUserActionParams,
  RequiredUserActionValidator,
} from '../required-user-action-service';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { AlertService } from '../../alert/alert.service';
import { LoadingService } from '../../loading/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { JobSectionsService } from '../../job-section/logic/job-section.service';
import { TourService } from '../../tour/logic/tour.service';
import { DynFormsService } from '../../dyn-forms/logic/dyn-forms.service';
import { IMSId } from 'src/app/_model/ims-object';
import { LBSUtils } from 'src/app/_util/lbs-utils';
import { TimeUtils } from 'src/app/_util/time-utils';
import { Tour } from 'src/app/_model/tour';
import { DynForm } from 'src/app/_model/dyn-form';

@Injectable({
  providedIn: 'root',
})
export class TourEachDayFormRequiredUserAction
  implements RequiredUserActionValidator
{
  // Public Member
  public readonly type: RequiredUserAction = 'toureachdayform';

  // Private Memeber
  private currentTour: Tour;
  private amountOfDays: number;
  private amountOfForms: number;
  private formname: string;

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private clientStateService: ClientStateService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private tourService: TourService,
    private dynFormService: DynFormsService,
  ) {}

  // RequiredUserActionService
  public async isFullfilled(
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    this.logger.log(
      this.constructor.name,
      'isFullfilled with',
      params,
      params.formid,
      params.objRef,
    );

    const formId: IMSId = {
      imsId: +params.formid,
      secondaryId: undefined,
      objRef: 'ims/DynForm',
    };
    const form = this.dynFormService.getDynFormById(formId);
    this.formname = form?.name ?? '_undefined_';
    this.currentTour = this.tourService.getTourById(
      this.clientStateService.theState.getValue().tourId,
    );

    this.logger.log(
      this.constructor.name,
      'check tour',
      this.currentTour?.displayLabel,
      'for form',
      formId,
      'objRef',
      params.objRef,
    );
    this.amountOfDays = TimeUtils.getDayBetweenTimestamps(
      this.currentTour.plannedstarttstamp,
      Date.now(),
    );
    this.logger.log(
      this.constructor.name,
      'tourstart plandate',
      this.currentTour.plannedstarttstamp,
      'need to check for',
      this.amountOfDays,
      'amount of forms',
    );

    this.amountOfForms =
      await this.dynFormService.getAmountOfFinishedDynFormForObjRefSince(
        formId,
        params.objRef,
        +this.currentTour.plannedstarttstamp,
      );

    this.logger.log(
      this.constructor.name,
      'found amount of forms',
      this.amountOfForms,
    );

    const isFullfilled = this.amountOfForms >= this.amountOfDays;
    this.logger.log(this.constructor.name, 'isFullfilled result', isFullfilled);
    return isFullfilled;
  }

  public async showSoftWarning(
    params: RequiredUserActionParams,
  ): Promise<boolean> {
    await this.loadingService.dismissLoading();

    const returnPromise = new Promise<boolean>(async (resolve) => {
      await this.alertService.showAlert(
        this.translate.instant(
          'REQUIRED-USER-ACTION.TOUREACHDAYFORM.SOFT.TITLE',
        ),
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.TOUREACHDAYFORM.SOFT.MESSAGE',
          {
            formname: this.formname,
            amountofdays: this.amountOfDays,
            amountofforms: this.amountOfForms,
          },
        ),
        this.translate.instant(
          'REQUIRED-USER-ACTION.TOUREACHDAYFORM.SOFT.CONFIRM',
        ),
        async () => {
          await this.loadingService.showLoading();
          resolve(true);
        },
        async () => {
          await this.loadingService.showLoading();
          resolve(false);
        },
        [],
        true,
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.TOUREACHDAYFORM.SOFT.CANCEL',
        ),
        [],
      );
    });

    return returnPromise;
  }
  public async showHardWarning(
    params: RequiredUserActionParams,
  ): Promise<void> {
    await this.loadingService.dismissLoading();

    const returnPromise = new Promise<void>(async (resolve) => {
      await this.alertService.showAlert(
        this.translate.instant(
          'REQUIRED-USER-ACTION.TOUREACHDAYFORM.HARD.TITLE',
        ),
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.TOUREACHDAYFORM.HARD.MESSAGE',
          {
            formname: this.formname,
            amountofdays: this.amountOfDays,
            amountofforms: this.amountOfForms,
          },
        ),
        undefined,
        undefined,
        async () => {
          await this.loadingService.showLoading();
          resolve();
        },
        [],
        true,
        undefined,
        this.translate.instant(
          'REQUIRED-USER-ACTION.PHOTODOC.TOUREACHDAYFORM.CANCEL',
        ),
        [],
      );
    });

    return returnPromise;
  }
}
